import { connect } from "react-redux"
import { useNavigate } from "react-router-dom"
import { MdKeyboardArrowLeft, MdCastConnected, MdAirplay } from "react-icons/md"
import { FaChromecast, FaPlay, FaRegClosedCaptioning, FaClosedCaptioning } from "react-icons/fa"
import { AiOutlinePause } from "react-icons/ai"
import { RiPictureInPicture2Fill } from "react-icons/ri"
import { GrBackTen, GrForwardTen } from "react-icons/gr"
import { BiSkipPrevious, BiSkipNext } from "react-icons/bi"
import { SendCastDetails2 } from "../../../../redux/v2/cast/actions";
import { callSocket } from "../../../../utils/socket"

import RangeSlider from "../../../RangeSlider"
import CustomButton from "../../../CustomButton"

import "./style.css";
import { useEffect } from "react"

function VideoControls2(props) {
    const {
        video = {},
        fadetype = false,
        playStatus = "play",
        AlwaysShowControls = () => { },
        FadeController = () => { },
        CloseController = () => { },
        CloseVideo = () => { },
        Pause = () => { },
        Resume = () => { },
        Move = () => { },
        Restart = () => { },
        PicInPic = () => { },
        isIntro,
        SendCastDetails = () => { },
        PlayCastDevice = () => { },
        PauseCastDevice = () => { },
        EnableCaption = () => { },
        isCaptionEnabled = false,
    } = props;

    const dt = localStorage.getItem("indi-device-type");
    const platform = localStorage.getItem("indi-platform");
    const isUsingApp = platform && (platform === "ios-app" || platform === "android-app");
    const native = props?.Cast?.native;

    useEffect(() => {
        if (native.isPlayingCast) {
            SendCastDetails();
        }
    }, [native.isPlayingCast]);

    const navigate = useNavigate();

    const isCasting = native.isPlayingCast && native.playingVideo?.video_id === video?.vimeoId;


    return (
        <>
            {
                // isCasting && <div className="casting-cover vco-2" >
                //     {/* true && <div className="casting-cover vco-2" > */}
                //     {/* <CustomButton isPrimary={false} onClick={() => {
                //         SendCastDetails();
                //     }}>Cast</CustomButton> */}
                //     <MdCastConnected className="vc-cast" onClick={() => {
                //         SendCastDetails();
                //         Pause();
                //     }} />
                //     <p>CASTING</p>
                // </div>
            }
            <div id="video-controls-overlay-2" className={(fadetype ? `fade${fadetype}` : "") + " " + (isCasting ? "is-casting" : "")} onClick={(e) => {
                if (fadetype == "none") {
                    FadeController();
                } else if (fadetype == "in" && (e.target.id == "video-controls-overlay-2" || (e?.target?.className.hasOwnProperty("includes") && e?.target?.className?.includes?.("free-click")))) {
                    CloseController();
                }
            }}>
                <div className="free-click vc-bottom">
                    <>
                        {
                            !isCasting &&
                            <div className="next-prev">
                                <div onClick={Restart}>
                                    <BiSkipPrevious />
                                    <h5>RESTART</h5>
                                </div>
                                {!isIntro && <div onClick={() => {
                                    navigate(`/workout?workout=${video.videoId + 1}`);
                                }}>
                                    <h5>NEXT EPISODE</h5>
                                    <BiSkipNext />
                                </div>}
                            </div>
                        }

                        <div className="custom-r-slider">
                            <RangeSlider
                                value={video.watchedTime}
                                max={video.duration}
                                onChange={(val) => {
                                    // FadeController();
                                    Move(val - video.watchedTime)
                                }}
                                onTouchStart={(e) => {
                                    AlwaysShowControls();
                                }}

                                onTouchEnd={(e) => {
                                    FadeController();
                                }}
                            />
                        </div>

                    </>

                </div>

                <div className="free-click vc-center">
                    <GrBackTen onClick={() => { Move(-10) }} />
                    <>
                        {playStatus == "play" && <AiOutlinePause onClick={() => {
                            if (native?.isPlayingCast) {
                                // PauseCastDevice();
                            } else {
                                Pause();
                            }
                        }} />}
                        {playStatus == "pause" && <FaPlay onClick={() => {
                            if (native?.isPlayingCast) {
                                // PlayCastDevice();
                            } else {
                                Resume();
                            }
                        }} />}
                    </>

                    <GrForwardTen onClick={() => { Move(10) }} />
                </div>

                <div className="free-click vc-top">
                    <MdKeyboardArrowLeft className="vc-back" onClick={() => {
                        CloseVideo();
                    }} />
                    <h4 className="txt-90d">{video?.videoTitle?.toUpperCase()}</h4>

                    <div className="vc-top-right-icons">
                        {
                            (isUsingApp)
                                ? (
                                    native?.isPlayingCast
                                        ? <MdCastConnected className="vc-cast vc-MdCastConnected" onClick={() => {
                                            SendCastDetails();
                                            Pause();
                                        }} />
                                        : <FaChromecast className="vc-cast vc-FaChromecast" onClick={() => {
                                            SendCastDetails();
                                            Pause();
                                        }} />
                                )
                                : <span></span>
                        }
                        {
                            ((isUsingApp && native?.airplayAvailable)) && <>
                                {
                                    native?.airplayConnected
                                        ? <MdAirplay onClick={() => {
                                            callSocket("/interact-native-component", { type: "airplay", subtype: "connect" });
                                        }} />
                                        : <MdAirplay onClick={() => {
                                            callSocket("/interact-native-component", { type: "airplay", subtype: "connect" });
                                        }} />
                                }

                            </>
                        }
                        {((isUsingApp) && (dt != "android" && platform != "android-app")) && <RiPictureInPicture2Fill onClick={PicInPic} />}
                        {!isCaptionEnabled && < FaRegClosedCaptioning onClick={EnableCaption} />}
                        {isCaptionEnabled && < FaClosedCaptioning onClick={EnableCaption} />}
                    </div>
                </div>

            </div>
        </>

    );
}

const mapStateToProps = (state) => ({
    Cast: state.Cast
});

export default connect(mapStateToProps, {
    SendCastDetails2,
})(VideoControls2);

